/* tslint:disable */
import {
  Admin,
  Prize,
  GameEmoji,
  GamePlayer,
  GameCategory,
  PlayerShare,
  Content,
  PlayerPrize,
  Reward,
  GeoPoint
} from '../index';

declare var Object: any;
export interface GameInterface {
  "adminId"?: any;
  "title"?: string;
  "drawDate"?: Date;
  "logo"?: any;
  "value"?: string;
  "categoryId"?: any;
  "textRules"?: string;
  "imageRule"?: any;
  "gameMenuArt"?: any;
  "gameMenuLayer"?: any;
  "automatchButtonArt"?: any;
  "selfPickButtonArt"?: any;
  "titleOpt"?: any;
  "shadowOpt"?: any;
  "categoryOpt"?: any;
  "submittedEmojiSmallFormat"?: boolean;
  "isGameMenuToolbar"?: boolean;
  "invites"?: Array<any>;
  "powerBar"?: any;
  "inviteType"?: string;
  "isInviteImageArtGradient"?: boolean;
  "isProgressBarTransparent"?: boolean;
  "embededVideoRules"?: string;
  "ruleTextRange"?: number;
  "grid"?: any;
  "prizeMode"?: string;
  "gameType"?: string;
  "gameFormat"?: string;
  "dressUpGroups"?: Array<any>;
  "dressUpFigure"?: any;
  "enterFreeOpt"?: any;
  "seatMapOpt"?: any;
  "isRounded"?: boolean;
  "isFill"?: boolean;
  "gameplayEmojiPosition"?: string;
  "gamePlayEmojiBackground "?: boolean;
  "gamePlayEmojiBackground"?: boolean;
  "isPrivate"?: boolean;
  "selectedPlayers"?: Array<any>;
  "restartedBy"?: string;
  "isRestartable"?: boolean;
  "isRegistration"?: boolean;
  "restartThreshold"?: number;
  "restartRequests"?: Array<any>;
  "selectedContent"?: Array<any>;
  "timeDifference"?: string;
  "restartCount"?: number;
  "shareCount"?: number;
  "notifyLocation"?: GeoPoint;
  "isLocation"?: boolean;
  "isLocationProximity"?: boolean;
  "locationRadius"?: number;
  "locationRadiusUnit"?: string;
  "isCompressed"?: boolean;
  "previousGameId"?: string;
  "sharingContentCountdown"?: Date;
  "schedule"?: string;
  "isSwipeMenu"?: boolean;
  "colorWheel"?: any;
  "tieBreakerColorWheel"?: any;
  "similarGames"?: any;
  "surveyOnly"?: boolean;
  "cycles"?: number;
  "registrationForm"?: any;
  "gameWinLosePreview"?: any;
  "gameTicket"?: any;
  "confirmationText"?: any;
  "embedWithTextContent"?: any;
  "imageWithTextContent"?: any;
  "id"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  admin?: Admin;
  prizes?: Prize[];
  emojis?: GameEmoji[];
  players?: GamePlayer[];
  category?: GameCategory;
  gameCategory?: GameCategory;
  playerShares?: PlayerShare[];
  contents?: Content[];
  playerPrize?: PlayerPrize[];
  rewards?: Reward[];
}

export class Game implements GameInterface {
  "adminId": any;
  "title": string;
  "drawDate": Date;
  "logo": any;
  "value": string;
  "categoryId": any;
  "textRules": string;
  "imageRule": any;
  "gameMenuArt": any;
  "gameMenuLayer": any;
  "automatchButtonArt": any;
  "selfPickButtonArt": any;
  "titleOpt": any;
  "shadowOpt": any;
  "categoryOpt": any;
  "submittedEmojiSmallFormat": boolean;
  "isGameMenuToolbar": boolean;
  "invites": Array<any>;
  "powerBar": any;
  "inviteType": string;
  "isInviteImageArtGradient": boolean;
  "isProgressBarTransparent": boolean;
  "embededVideoRules": string;
  "ruleTextRange": number;
  "grid": any;
  "prizeMode": string;
  "gameType": string;
  "gameFormat": string;
  "dressUpGroups": Array<any>;
  "dressUpFigure": any;
  "enterFreeOpt": any;
  "seatMapOpt": any;
  "isRounded": boolean;
  "isFill": boolean;
  "gameplayEmojiPosition": string;
  "gamePlayEmojiBackground ": boolean;
  "gamePlayEmojiBackground": boolean;
  "isPrivate": boolean;
  "selectedPlayers": Array<any>;
  "restartedBy": string;
  "isRestartable": boolean;
  "isRegistration": boolean;
  "restartThreshold": number;
  "restartRequests": Array<any>;
  "selectedContent": Array<any>;
  "timeDifference": string;
  "restartCount": number;
  "shareCount": number;
  "notifyLocation": GeoPoint;
  "isLocation": boolean;
  "isLocationProximity": boolean;
  "locationRadius": number;
  "locationRadiusUnit": string;
  "isCompressed": boolean;
  "previousGameId": string;
  "sharingContentCountdown": Date;
  "schedule": string;
  "isSwipeMenu": boolean;
  "colorWheel": any;
  "tieBreakerColorWheel": any;
  "similarGames": any;
  "surveyOnly": boolean;
  "cycles": number;
  "registrationForm": any;
  "gameWinLosePreview": any;
  "gameTicket": any;
  "confirmationText": any;
  "embedWithTextContent": any;
  "imageWithTextContent": any;
  "id": any;
  "createdAt": Date;
  "updatedAt": Date;
  admin: Admin;
  prizes: Prize[];
  emojis: GameEmoji[];
  players: GamePlayer[];
  category: GameCategory;
  gameCategory: GameCategory;
  playerShares: PlayerShare[];
  contents: Content[];
  playerPrize: PlayerPrize[];
  rewards: Reward[];
  constructor(data?: GameInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Game`.
   */
  public static getModelName() {
    return "Game";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Game for dynamic purposes.
  **/
  public static factory(data: GameInterface): Game{
    return new Game(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Game',
      plural: 'games',
      path: 'games',
      idName: 'id',
      properties: {
        "adminId": {
          name: 'adminId',
          type: 'any'
        },
        "title": {
          name: 'title',
          type: 'string'
        },
        "drawDate": {
          name: 'drawDate',
          type: 'Date'
        },
        "logo": {
          name: 'logo',
          type: 'any'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "categoryId": {
          name: 'categoryId',
          type: 'any'
        },
        "textRules": {
          name: 'textRules',
          type: 'string'
        },
        "imageRule": {
          name: 'imageRule',
          type: 'any'
        },
        "gameMenuArt": {
          name: 'gameMenuArt',
          type: 'any'
        },
        "gameMenuLayer": {
          name: 'gameMenuLayer',
          type: 'any'
        },
        "automatchButtonArt": {
          name: 'automatchButtonArt',
          type: 'any'
        },
        "selfPickButtonArt": {
          name: 'selfPickButtonArt',
          type: 'any'
        },
        "titleOpt": {
          name: 'titleOpt',
          type: 'any'
        },
        "shadowOpt": {
          name: 'shadowOpt',
          type: 'any'
        },
        "categoryOpt": {
          name: 'categoryOpt',
          type: 'any'
        },
        "submittedEmojiSmallFormat": {
          name: 'submittedEmojiSmallFormat',
          type: 'boolean',
          default: false
        },
        "isGameMenuToolbar": {
          name: 'isGameMenuToolbar',
          type: 'boolean',
          default: false
        },
        "invites": {
          name: 'invites',
          type: 'Array&lt;any&gt;'
        },
        "powerBar": {
          name: 'powerBar',
          type: 'any'
        },
        "inviteType": {
          name: 'inviteType',
          type: 'string',
          default: 'image'
        },
        "isInviteImageArtGradient": {
          name: 'isInviteImageArtGradient',
          type: 'boolean',
          default: false
        },
        "isProgressBarTransparent": {
          name: 'isProgressBarTransparent',
          type: 'boolean',
          default: false
        },
        "embededVideoRules": {
          name: 'embededVideoRules',
          type: 'string'
        },
        "ruleTextRange": {
          name: 'ruleTextRange',
          type: 'number'
        },
        "grid": {
          name: 'grid',
          type: 'any'
        },
        "prizeMode": {
          name: 'prizeMode',
          type: 'string'
        },
        "gameType": {
          name: 'gameType',
          type: 'string',
          default: 'new'
        },
        "gameFormat": {
          name: 'gameFormat',
          type: 'string',
          default: 'standard'
        },
        "dressUpGroups": {
          name: 'dressUpGroups',
          type: 'Array&lt;any&gt;'
        },
        "dressUpFigure": {
          name: 'dressUpFigure',
          type: 'any'
        },
        "enterFreeOpt": {
          name: 'enterFreeOpt',
          type: 'any'
        },
        "seatMapOpt": {
          name: 'seatMapOpt',
          type: 'any'
        },
        "isRounded": {
          name: 'isRounded',
          type: 'boolean',
          default: false
        },
        "isFill": {
          name: 'isFill',
          type: 'boolean',
          default: false
        },
        "gameplayEmojiPosition": {
          name: 'gameplayEmojiPosition',
          type: 'string',
          default: 'top'
        },
        "gamePlayEmojiBackground ": {
          name: 'gamePlayEmojiBackground ',
          type: 'boolean',
          default: false
        },
        "gamePlayEmojiBackground": {
          name: 'gamePlayEmojiBackground',
          type: 'boolean',
          default: false
        },
        "isPrivate": {
          name: 'isPrivate',
          type: 'boolean',
          default: false
        },
        "selectedPlayers": {
          name: 'selectedPlayers',
          type: 'Array&lt;any&gt;'
        },
        "restartedBy": {
          name: 'restartedBy',
          type: 'string'
        },
        "isRestartable": {
          name: 'isRestartable',
          type: 'boolean',
          default: false
        },
        "isRegistration": {
          name: 'isRegistration',
          type: 'boolean',
          default: false
        },
        "restartThreshold": {
          name: 'restartThreshold',
          type: 'number',
          default: 0
        },
        "restartRequests": {
          name: 'restartRequests',
          type: 'Array&lt;any&gt;'
        },
        "selectedContent": {
          name: 'selectedContent',
          type: 'Array&lt;any&gt;'
        },
        "timeDifference": {
          name: 'timeDifference',
          type: 'string'
        },
        "restartCount": {
          name: 'restartCount',
          type: 'number',
          default: 0
        },
        "shareCount": {
          name: 'shareCount',
          type: 'number',
          default: 0
        },
        "notifyLocation": {
          name: 'notifyLocation',
          type: 'GeoPoint'
        },
        "isLocation": {
          name: 'isLocation',
          type: 'boolean',
          default: false
        },
        "isLocationProximity": {
          name: 'isLocationProximity',
          type: 'boolean',
          default: false
        },
        "locationRadius": {
          name: 'locationRadius',
          type: 'number'
        },
        "locationRadiusUnit": {
          name: 'locationRadiusUnit',
          type: 'string'
        },
        "isCompressed": {
          name: 'isCompressed',
          type: 'boolean',
          default: false
        },
        "previousGameId": {
          name: 'previousGameId',
          type: 'string'
        },
        "sharingContentCountdown": {
          name: 'sharingContentCountdown',
          type: 'Date'
        },
        "schedule": {
          name: 'schedule',
          type: 'string'
        },
        "isSwipeMenu": {
          name: 'isSwipeMenu',
          type: 'boolean',
          default: false
        },
        "colorWheel": {
          name: 'colorWheel',
          type: 'any'
        },
        "tieBreakerColorWheel": {
          name: 'tieBreakerColorWheel',
          type: 'any'
        },
        "similarGames": {
          name: 'similarGames',
          type: 'any'
        },
        "surveyOnly": {
          name: 'surveyOnly',
          type: 'boolean',
          default: false
        },
        "cycles": {
          name: 'cycles',
          type: 'number'
        },
        "registrationForm": {
          name: 'registrationForm',
          type: 'any'
        },
        "gameWinLosePreview": {
          name: 'gameWinLosePreview',
          type: 'any'
        },
        "gameTicket": {
          name: 'gameTicket',
          type: 'any'
        },
        "confirmationText": {
          name: 'confirmationText',
          type: 'any',
          default: <any>null
        },
        "embedWithTextContent": {
          name: 'embedWithTextContent',
          type: 'any',
          default: <any>null
        },
        "imageWithTextContent": {
          name: 'imageWithTextContent',
          type: 'any',
          default: <any>null
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        admin: {
          name: 'admin',
          type: 'Admin',
          model: 'Admin',
          relationType: 'belongsTo',
                  keyFrom: 'adminId',
          keyTo: 'id'
        },
        prizes: {
          name: 'prizes',
          type: 'Prize[]',
          model: 'Prize',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'gameId'
        },
        emojis: {
          name: 'emojis',
          type: 'GameEmoji[]',
          model: 'GameEmoji',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'gameId'
        },
        players: {
          name: 'players',
          type: 'GamePlayer[]',
          model: 'GamePlayer',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'gameId'
        },
        category: {
          name: 'category',
          type: 'GameCategory',
          model: 'GameCategory',
          relationType: 'belongsTo',
                  keyFrom: 'categoryId',
          keyTo: 'id'
        },
        gameCategory: {
          name: 'gameCategory',
          type: 'GameCategory',
          model: 'GameCategory',
          relationType: 'belongsTo',
                  keyFrom: 'categoryId',
          keyTo: 'id'
        },
        playerShares: {
          name: 'playerShares',
          type: 'PlayerShare[]',
          model: 'PlayerShare',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        contents: {
          name: 'contents',
          type: 'Content[]',
          model: 'Content',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'gameId'
        },
        playerPrize: {
          name: 'playerPrize',
          type: 'PlayerPrize[]',
          model: 'PlayerPrize',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'gameId'
        },
        rewards: {
          name: 'rewards',
          type: 'Reward[]',
          model: 'Reward',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'gameId'
        },
      }
    }
  }
}
